// Setup-screen strings (Spanish) — must provide every key of setupEn
// (checked by its type). Split out of messages.ts alongside messagesEn.ts.

import type { SetupMessageKey } from './messagesEn.js';

export const setupEs: Record<SetupMessageKey, string> = {
  'setup.title': 'Nueva partida',
  'setup.back': 'Volver al menú',
  'setup.quickStart': 'Inicio rápido',
  'setup.quickStartLabel': 'Inicio rápido: jugar {name} ahora mismo',
  'setup.who': '¿Quién juega?',
  'setup.whoHint': 'Elige las reglas que encajan con quien juega. Puedes ajustarlo todo abajo.',
  'setup.ageBadge': '{age}+',
  'setup.ageLabel': 'Desde {age} años',
  'setup.sessionMin': '{min}–{max} min',
  'setup.sessionHours': '{min}–{max} h',
  'setup.selected': 'Seleccionado',
  'setup.custom': 'Personalizada (basada en {name})',
  'setup.reset': 'Volver a {name}',

  'setup.preset.explorer': 'Explorador',
  'setup.preset.explorer.tagline': 'La primera aventura perfecta',
  'setup.preset.explorer.b1': 'Mapa diminuto con un vecino amistoso',
  'setup.preset.explorer.b2': 'Gana cumpliendo metas divertidas',
  'setup.preset.explorer.b3': 'Mucha ayuda y nunca pierdes del todo',
  'setup.preset.apprentice': 'Aprendiz',
  'setup.preset.apprentice.tagline': 'Aprende lo básico',
  'setup.preset.apprentice.b1': 'Mapa pequeño con dos rivales fáciles',
  'setup.preset.apprentice.b2': 'Añade niebla de guerra, caminos y fe',
  'setup.preset.apprentice.b3': 'Cinco minutos de paz para asentarte',
  'setup.preset.standard': 'Estándar',
  'setup.preset.standard.tagline': 'El juego completo, a buen ritmo',
  'setup.preset.standard.b1': 'Doctrinas, magia e investigación',
  'setup.preset.standard.b2': 'Tres rivales en un mapa mediano',
  'setup.preset.standard.b3': 'Gana por conquista, riqueza, ciencia o fe',
  'setup.preset.strategist': 'Estratega',
  'setup.preset.strategist.tagline': 'Todos los sistemas, rivales duros',
  'setup.preset.strategist.b1': 'Todas las reglas salvo temas maduros',
  'setup.preset.strategist.b2': 'Cuatro rivales difíciles en un mapa grande',
  'setup.preset.strategist.b3': 'Diplomacia completa, espías y guerra naval',
  'setup.preset.grand': 'Gran Dominio',
  'setup.preset.grand.tagline': 'Para gobernantes veteranos',
  'setup.preset.grand.b1': 'Todas las reglas, incluidos temas maduros',
  'setup.preset.grand.b2': 'Seis rivales brutales a ritmo rápido',
  'setup.preset.grand.b3': 'Sin treguas y sin pistas',

  'setup.preset.highlands': 'Tierras Altas',
  'setup.preset.highlands.tagline': 'La tierra misma es la rival',
  'setup.preset.highlands.b1': 'El terreno sube por niveles: domina las alturas',
  'setup.preset.highlands.b2': 'Los defensores en cimas reciben un cuarto del daño',
  'setup.preset.highlands.b3': 'Las cimas siguen salvajes: funda pueblos bajo el nivel 8',
  'setup.preset.legends': 'Campeones',
  'setup.preset.legends.tagline': 'Una leyenda que cambia la guerra',
  'setup.preset.legends.b1': 'Invoca un Dragón con una doctrina y un largo proyecto',
  'setup.preset.legends.b2': 'Arqueros y torres disparan más fuerte a los voladores',
  'setup.preset.legends.b3': 'Si cae, cuesta menos traerlo de vuelta',
  'setup.preset.seafarers': 'Navegantes',
  'setup.preset.seafarers.tagline': 'Domina las olas',
  'setup.preset.seafarers.b1': 'Construye barcos mercantes y hazlos navegar entre puertos',
  'setup.preset.seafarers.b2': 'Carga mercancía en tu puerto y véndela en el extranjero',
  'setup.preset.seafarers.b3': 'Los puertos y las rutas marítimas se pagan solos',
  'setup.preset.royal-houses': 'Casas Reales',
  'setup.preset.royal-houses.tagline': 'Cásate por la corona',
  'setup.preset.royal-houses.b1': 'Cada asiento tiene su corte real: una mujer y un hombre',
  'setup.preset.royal-houses.b2': 'Los matrimonios sellan alianzas; romper uno cuesta honor',
  'setup.preset.royal-houses.b3': 'La IA valora un matrimonio y ofrece el suyo propio',
  'setup.preset.royal-houses.b4': 'Nacen hijos, los herederos crecen y una línea muerta adopta',
  'setup.preset.royal-houses.b5':
    'Tus espías sabotean, asesinan y envenenan; los contraespías lo vigilan',
  'setup.climate': 'Clima',
  'setup.climate.temperate': 'Templado',
  'setup.climate.arctic': 'Ártico',
  'setup.climate.tropical': 'Tropical',
  'setup.climate.desert': 'Desierto',
  'setup.sea': 'Mar',
  'setup.sea.desc':
    'El Rim mantiene la franja costera; Tierra Adentro cierra el mapa en montañas (sin puertos ni barcos); Mar Abierto añade océano profundo; Archipiélago son islas (solo formas circulares).',
  'setup.sea.rim': 'Rim',
  'setup.sea.landlocked': 'Tierra Adentro',
  'setup.sea.open': 'Mar Abierto',
  'setup.sea.archipelago': 'Archipiélago',
  'setup.thirst': 'Sed',
  'setup.thirst.desc':
    'Las unidades llevan una cantimplora y solo sufren daño cuando se vacía. Auto la activa desde la dificultad 3 de la IA (Normal).',
  'setup.thirst.auto': 'Auto',
  'setup.thirst.on': 'Sí',
  'setup.thirst.off': 'No',
  'setup.yearLength': 'Duración del año',
  'setup.yearLength.desc':
    'Minutos reales por año del juego: la velocidad del reloj, las estaciones y (en partidas con casas reales) de las dinastías. 6 es el ritmo clásico; 2 es una saga rápida, 12 una lenta. Se fija al empezar la partida.',
  'setup.customize': 'Personalizar',
  'setup.customizeHint': 'Reglas, mundo, jugadores y contenido',
  'setup.tabs': 'Personalizar la partida',
  'setup.tab.rules': 'Reglas',
  'setup.tab.world': 'Mundo',
  'setup.tab.players': 'Jugadores',
  'setup.tab.content': 'Contenido',
  'setup.core': 'Siempre activo: ciudades, unidades, movimiento, combate, comida y oro.',

  'setup.cat.economy': 'Economía',
  'setup.cat.doctrine': 'Doctrinas',
  'setup.cat.heroes': 'Héroes',
  'setup.cat.combat': 'Combate',
  'setup.cat.faith': 'Fe',
  'setup.cat.magic': 'Magia',
  'setup.cat.science': 'Ciencia',
  'setup.cat.diplomacy': 'Diplomacia',
  'setup.cat.espionage': 'Espionaje',
  'setup.cat.world': 'Mundo',
  'setup.cat.mature': 'Temas maduros',
  'setup.cat.pacing': 'Ritmo',
  'setup.cat.victory': 'Formas de ganar',
  'setup.cat.sea': 'Mar',

  'setup.module.economy.upkeep': 'Mantenimiento',
  'setup.module.economy.upkeep.desc': 'Unidades y héroes cuestan oro cada turno',
  'setup.module.economy.upkeep.kid': 'Los soldados necesitan oro para quedarse',
  'setup.module.economy.starvation': 'Hambruna',
  'setup.module.economy.starvation.desc': 'Las ciudades menguan si se acaba la comida',
  'setup.module.economy.starvation.kid': 'Las ciudades necesitan comida para crecer',
  'setup.module.economy.supply': 'Depósitos y convoyes',
  'setup.module.economy.supply.desc': 'Los ejércitos se abastecen desde depósitos',
  'setup.module.economy.supply.kid': 'Carros que llevan comida a tu ejército',
  'setup.module.economy.roads': 'Caminos',
  'setup.module.economy.roads.desc': 'Construye caminos para moverte más rápido',
  'setup.module.economy.roads.kid': 'Los caminos acortan los viajes',
  'setup.module.economy.trade_routes': 'Rutas comerciales',
  'setup.module.economy.trade_routes.desc': 'Une ciudades para tener ingresos fijos',
  'setup.module.economy.trade_routes.kid': 'Las ciudades comercian y ganan oro',
  'setup.module.diplomacy.dynasty': 'Bodas reales',
  'setup.module.diplomacy.dynasty.desc': 'Sella alianzas casándote con una familia real',
  'setup.module.diplomacy.dynasty.kid': 'Las familias reales se casan para ser amigas',
  'setup.module.sea.trade': 'Barcos mercantes',
  'setup.module.sea.trade.desc': 'Navega con carga entre puertos para ganar oro',
  'setup.module.sea.trade.kid': 'Los barcos llevan mercancía a puertos lejanos',
  'setup.module.doctrine.enabled': 'Doctrinas',
  'setup.module.doctrine.enabled.desc': 'Invierte en seis escuelas de pensamiento',
  'setup.module.doctrine.enabled.kid': 'Elige en qué cree tu pueblo',
  'setup.module.heroes.enabled': 'Héroes',
  'setup.module.heroes.enabled.desc': 'Recluta héroes con habilidades especiales',
  'setup.module.heroes.enabled.kid': 'Héroes con superpoderes',
  'setup.module.heroes.loyalty': 'Lealtad de los héroes',
  'setup.module.heroes.loyalty.desc': 'Los héroes descontentos pueden desertar',
  'setup.module.heroes.loyalty.kid': 'Mantén contentos a tus héroes',
  'setup.module.heroes.captivity': 'Cautiverio de héroes',
  'setup.module.heroes.captivity.desc': 'Un héroe derrotado puede ser capturado',
  'setup.module.heroes.captivity.kid': 'Puedes atrapar a un héroe que pierde un combate',
  'setup.module.heroes.quests': 'Órdenes de héroes',
  'setup.module.heroes.quests.desc': 'Da órdenes a tus héroes y pagarás al cumplirlas',
  'setup.module.heroes.quests.kid': 'Dile a un héroe qué hacer y dale un regalo',
  'setup.module.espionage.ops': 'Órdenes de espías',
  'setup.module.espionage.ops.desc': 'Ordena a tus espías y asesinos golpear una ciudad enemiga',
  'setup.module.espionage.ops.kid': 'Manda a un espía sigiloso a romper algo',
  'setup.module.espionage.false_flag': 'Bandera falsa',
  'setup.module.espionage.false_flag.desc': 'Culpa a otra casa de lo que hacen tus espías',
  'setup.module.espionage.false_flag.kid': 'Haz que otro cargue con la culpa',
  'setup.module.espionage.counter_intel': 'Contraespionaje',
  'setup.module.espionage.counter_intel.desc':
    'Apuesta contraespías, rastrea agentes ocultos, atrápalos y descubre las banderas falsas',
  'setup.module.espionage.counter_intel.kid': 'Atrapa a los espías sigilosos',
  'setup.module.diplomacy.generations': 'Generaciones',
  'setup.module.diplomacy.generations.desc':
    'Hijos reales, envejecimiento y sucesión: las casas continúan a lo largo de una vida',
  'setup.module.diplomacy.generations.kid': 'Los hijos reales crecen y heredan',
  'setup.module.combat.formations': 'Formaciones',
  'setup.module.combat.formations.desc': 'Organiza tus ejércitos para ganar ventajas',
  'setup.module.combat.formations.kid': 'Coloca tu ejército en formas astutas',
  'setup.module.combat.siege': 'Asedio',
  'setup.module.combat.siege.desc': 'Máquinas de asedio y ciudades amuralladas',
  'setup.module.combat.siege.kid': 'Grandes máquinas que rompen murallas',
  'setup.module.combat.naval': 'Naval',
  'setup.module.combat.naval.desc': 'Barcos, puertos y guerra en el mar',
  'setup.module.combat.naval.kid': 'Navega con barcos por el mar',
  'setup.module.faith.enabled': 'Fe',
  'setup.module.faith.enabled.desc': 'Genera fe, santifica tierras y sana',
  'setup.module.faith.enabled.kid': 'Templos que ayudan a tu pueblo',
  'setup.module.faith.crises': 'Crisis de fe',
  'setup.module.faith.crises.desc': 'La tensión religiosa puede estallar',
  'setup.module.faith.crises.kid': 'A veces la gente discute sus creencias',
  'setup.module.magic.enabled': 'Magia y maná',
  'setup.module.magic.enabled.desc': 'Magos, hechizos y líneas ley',
  'setup.module.magic.enabled.kid': 'Lanza hechizos mágicos',
  'setup.module.magic.rituals': 'Rituales',
  'setup.module.magic.rituals.desc': 'Hechizos de grupo largos y poderosos',
  'setup.module.magic.rituals.kid': 'Hechizos gigantes que llevan tiempo',
  'setup.module.science.research': 'Investigación',
  'setup.module.science.research.desc': 'Invierte conocimiento en grandes avances',
  'setup.module.science.research.kid': 'Descubre ideas nuevas',
  'setup.module.diplomacy.basic': 'Guerra y paz',
  'setup.module.diplomacy.basic.desc': 'Declara la guerra y firma la paz',
  'setup.module.diplomacy.basic.kid': 'Haz amigos o lucha',
  'setup.module.diplomacy.full': 'Tratados y vasallos',
  'setup.module.diplomacy.full.desc': 'Alianzas, vasallos, federaciones y tributos',
  'setup.module.diplomacy.full.kid': 'Haz tratos con otros gobernantes',
  'setup.module.espionage.enabled': 'Espías y sabotaje',
  'setup.module.espionage.enabled.desc': 'Espía, sabotea y provoca revueltas',
  'setup.module.espionage.enabled.kid': 'Espías sigilosos',
  'setup.module.world.neutrals': 'Bandidos y piratas',
  'setup.module.world.neutrals.desc': 'Asaltantes neutrales y pueblos independientes',
  'setup.module.world.neutrals.kid': 'Ladrones que recorren la tierra',
  'setup.module.world.ruins': 'Ruinas y tesoros',
  'setup.module.world.ruins.desc': 'Explora ruinas en busca de recompensas',
  'setup.module.world.ruins.kid': 'Encuentra tesoros escondidos',
  'setup.module.world.fog_of_war': 'Niebla de guerra',
  'setup.module.world.fog_of_war.desc': 'Solo ves lo que ven tus unidades',
  'setup.module.world.fog_of_war.kid': 'Explora para descubrir el mapa',
  'setup.module.mature.slavery': 'Esclavitud y revueltas',
  'setup.module.mature.slavery.desc': 'Esclaviza cautivos y arriesga revueltas',
  'setup.module.mature.slavery.kid': 'No apto para jugadores jóvenes',
  'setup.module.mature.sacrifice': 'Sacrificio',
  'setup.module.mature.sacrifice.desc': 'Ritos y sacerdotes de sangre',
  'setup.module.mature.sacrifice.kid': 'No apto para jugadores jóvenes',
  'setup.module.pacing.truce': 'Treguas',
  'setup.module.pacing.truce.desc': 'Un respiro tras las grandes batallas',
  'setup.module.pacing.truce.kid': 'Un descanso tras una gran pelea',
  'setup.module.pacing.intensity': 'Límite de intensidad',
  'setup.module.pacing.intensity.desc': 'Los rivales aflojan cuando la presión es máxima',
  'setup.module.pacing.intensity.kid': 'Los rivales frenan si se pone muy difícil',
  'setup.module.victory.conquest': 'Victoria por conquista',
  'setup.module.victory.conquest.desc': 'Toma todas las capitales rivales',
  'setup.module.victory.conquest.kid': 'Gana capturando ciudades',
  'setup.module.victory.economic': 'Victoria económica',
  'setup.module.victory.economic.desc': 'Construye el imperio más rico',
  'setup.module.victory.economic.kid': 'Gana siendo el más rico',
  'setup.module.victory.science': 'Victoria científica',
  'setup.module.victory.science.desc': 'Alcanza los avances finales',
  'setup.module.victory.science.kid': 'Gana con descubrimientos ingeniosos',
  'setup.module.victory.faith': 'Victoria de la fe',
  'setup.module.victory.faith.desc': 'Extiende tu fe por todo el mundo',
  'setup.module.victory.faith.kid': 'Gana compartiendo tus creencias',
  'setup.module.victory.diplomatic': 'Victoria diplomática',
  'setup.module.victory.diplomatic.desc': 'Lidera una federación de naciones',
  'setup.module.victory.diplomatic.kid': 'Gana haciendo amigos',
  'setup.module.victory.milestones': 'Victoria por metas',
  'setup.module.victory.milestones.desc': 'Cumple metas como fundar ciudades o reclutar un héroe',
  'setup.module.victory.milestones.kid': 'Gana cumpliendo metas divertidas',
  'setup.module.terrain.levels': 'Niveles de terreno',
  'setup.module.terrain.levels.desc': 'La altura sube por niveles: la tierra alta importa',
  'setup.module.terrain.levels.kid': 'Montañas y valles que de verdad se elevan',
  'setup.authored.title': 'Jugar un mapa de autor',
  'setup.authored.desc':
    'Importa un mapa creado en AOD Studio (un archivo JSON aod-map). El tablero viene del mapa; las reglas las eliges tú.',
  'setup.authored.import': 'Importar un mapa',
  'setup.authored.clear': 'Quitar el mapa',
  'setup.authored.problems': '{count} problemas con este mapa',
  'setup.authored.invalid': 'Eso no parece un mapa de AOD',
  'setup.cat.map': 'Mapa',
  'setup.module.map.custom': 'Mapa de autor',
  'setup.module.map.custom.desc':
    'Se activa al jugar un mapa creado en AOD Studio. Sin efecto en una partida normal.',
  'setup.module.map.custom.kid': 'Para mapas creados en AOD Studio',
  'setup.module.legends.enabled': 'Campeones',
  'setup.module.legends.enabled.desc':
    'Gana una criatura legendaria, un Dragón, con un largo proyecto de invocación',
  'setup.module.legends.enabled.kid': 'Llama a un dragón gigante para que luche por ti',

  'setup.alsoOff': 'Desactivar {name} también desactiva {list}.',
  'setup.alsoOn': 'Activar {name} también activa {list}.',
  'setup.needs': 'Necesita {list}',
  'setup.lockedFamily': 'Desactivado con la clasificación Familiar',
  'setup.undo': 'Deshacer',

  'setup.problems': 'Corrige esto antes de empezar',
  'setup.problemCount': 'Corrige las reglas para empezar',
  'setup.problem.needs': '{module} necesita {dependency}',
  'setup.problem.noVictory': 'Elige al menos una forma de ganar',
  'setup.problem.family': 'La clasificación Familiar excluye los temas maduros',
  'setup.problem.aiRange': 'Elige entre 1 y 7 rivales IA',
  'setup.problem.peaceRange': 'El periodo de paz debe ser de 0–20 min',
  'setup.problem.truceRange': 'Una tregua debe durar 0–5 min',
  'setup.problem.unknown': 'Regla desconocida: {id}',

  'setup.minutes': '{min} min',
  'setup.off': 'No',
  'setup.tuning.pace': 'Ritmo',
  'setup.tuning.pace.relaxed': 'Tranquilo',
  'setup.tuning.pace.normal': 'Normal',
  'setup.tuning.pace.brisk': 'Rápido',
  'setup.tuning.mapSize': 'Tamaño del mapa',
  'setup.tuning.mapSize.tiny': 'Diminuto',
  'setup.tuning.mapSize.small': 'Pequeño',
  'setup.tuning.mapSize.medium': 'Mediano',
  'setup.tuning.mapSize.large': 'Grande',
  'setup.tuning.startingResources': 'Recursos iniciales',
  'setup.tuning.startingResources.low': 'Pocos',
  'setup.tuning.startingResources.normal': 'Normales',
  'setup.tuning.startingResources.high': 'Muchos',
  'setup.tuning.victoryLength': 'Duración de la partida',
  'setup.tuning.victoryLength.short': 'Corta',
  'setup.tuning.victoryLength.normal': 'Normal',
  'setup.tuning.victoryLength.long': 'Larga',
  'setup.tuning.peacePeriod': 'Periodo de paz',
  'setup.tuning.peacePeriod.desc': 'Ningún rival te ataca antes de este tiempo',
  'setup.tuning.cityCanBeDestroyed': 'La última ciudad puede caer',
  'setup.tuning.cityCanBeDestroyed.desc':
    'Si está desactivado, recibes un refugio en vez de perder pronto',
  'setup.tuning.truceMin': 'Duración de la tregua',
  'setup.tuning.truceMin.desc': 'Una pausa en la lucha tras una batalla decisiva',
  'setup.tuning.intensityCeiling': 'Límite de presión rival',
  'setup.tuning.intensityCeiling.low': 'Baja',
  'setup.tuning.intensityCeiling.medium': 'Media',
  'setup.tuning.intensityCeiling.high': 'Alta',
  'setup.tuning.intensityCeiling.off': 'Sin límite',
  'setup.decrease': 'Menos: {label}',
  'setup.increase': 'Más: {label}',

  'setup.players.rivals': 'Rivales',
  'setup.players.opponents': 'Rivales IA',
  'setup.players.profile': 'Dificultad de la IA',
  'setup.players.profile.gentle': 'Amable',
  'setup.players.profile.easy': 'Fácil',
  'setup.players.profile.normal': 'Normal',
  'setup.players.profile.hard': 'Difícil',
  'setup.players.profile.brutal': 'Brutal',
  'setup.players.you': 'Tus ayudas',
  'setup.players.youHint': 'Ayuda solo para ti. Los rivales siguen las mismas reglas.',
  'setup.players.alignment': 'Alineación',
  'setup.players.alignment.desc': 'Elige la senda doctrinal inicial de tus ciudades.',
  'setup.players.alignment.none': 'Sin alinear',
  'setup.players.alignment.light': 'Luz',
  'setup.players.alignment.dark': 'Oscuridad',
  'setup.assist.handicap': 'Ventaja inicial',
  'setup.assist.handicap.none': 'Ninguna',
  'setup.assist.handicap.easy': 'Algo',
  'setup.assist.handicap.very_easy': 'Mucha',
  'setup.assist.autoManageCities': 'Ayudante de ciudades',
  'setup.assist.autoManageCities.off': 'No',
  'setup.assist.autoManageCities.suggest': 'Sugerir',
  'setup.assist.autoManageCities.auto': 'Automático',
  'setup.assist.hints': 'Pistas',
  'setup.assist.hints.off': 'No',
  'setup.assist.hints.smart': 'Inteligentes',
  'setup.assist.hints.always': 'Siempre',
  'setup.assist.revealMap': 'Revelar todo el mapa',
  'setup.assist.pauseOnDanger': 'Pausar ante el peligro',
  'setup.assist.pauseOnDanger.off': 'No',
  'setup.assist.pauseOnDanger.major': 'Grandes amenazas',
  'setup.assist.pauseOnDanger.all': 'Cualquier ataque',
  'setup.assist.uiMode': 'Interfaz',
  'setup.assist.uiMode.icons': 'Iconos',
  'setup.assist.uiMode.standard': 'Estándar',
  'setup.assist.uiMode.expert': 'Experta',
  'setup.assist.speedCap': 'Velocidad máxima',

  'setup.content.label': 'Clasificación de contenido',
  'setup.content.family': 'Familiar',
  'setup.content.family.desc': 'Sin temas maduros. Nombres y efectos más suaves.',
  'setup.content.teen': 'Adolescente',
  'setup.content.teen.desc': 'Los temas maduros están desactivados, pero puedes activarlos.',
  'setup.content.mature': 'Adulto',
  'setup.content.mature.desc': 'Todo disponible, incluidos la esclavitud y el sacrificio.',

  'setup.share.label': 'Código para compartir',
  'setup.share.hint': 'Envíalo a alguien para que juegue con las mismas reglas.',
  'setup.share.copy': 'Copiar el código',
  'setup.share.copied': 'Copiado',
  'setup.share.input': '¿Tienes un código? Pégalo aquí',
  'setup.share.apply': 'Usar código',
  'setup.share.applied': 'Código cargado',
  'setup.share.error.format': 'Eso no parece un código compartido',
  'setup.share.error.checksum': 'Parece que hay un carácter mal escrito',
  'setup.share.error.version': 'Este código es de una versión más nueva del juego',
  'setup.share.error.value': 'Los ajustes de este código no encajan entre sí',
  'setup.share.error.invalid': 'Los ajustes de este código no encajan entre sí',

  'setup.summary.label': 'Resumen de la partida',
  'setup.summary.map.tiny': 'mapa diminuto',
  'setup.summary.map.small': 'mapa pequeño',
  'setup.summary.map.medium': 'mapa mediano',
  'setup.summary.map.large': 'mapa grande',
  'setup.summary.ai.one': '1 IA {profile}',
  'setup.summary.ai.other': '{count} IA {profile}',
  'setup.summary.profile.gentle.one': 'amable',
  'setup.summary.profile.gentle.other': 'amables',
  'setup.summary.profile.easy.one': 'fácil',
  'setup.summary.profile.easy.other': 'fáciles',
  'setup.summary.profile.normal.one': 'normal',
  'setup.summary.profile.normal.other': 'normales',
  'setup.summary.profile.hard.one': 'difícil',
  'setup.summary.profile.hard.other': 'difíciles',
  'setup.summary.profile.brutal.one': 'brutal',
  'setup.summary.profile.brutal.other': 'brutales',
  'setup.summary.minutes': '~{min} min',
  'setup.summary.hours': '~{hours} h',
  'setup.start': 'Empezar',
  'setup.startLabel': 'Empezar la partida: {summary}',
};
